import type { ISerialize } from '@/objects/ISerialize';

export class IntArray implements ISerialize {
    public Values: number[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Values?: number[] }) {
        this.Values = values.Values ?? [];
    }

    public serialize(): string {
        return '{' + `"Values": [ ${this.Values.map((x) => JSON.stringify(x))} ]` + '}';
    }

    /**
     * Creates an instance of IntArray from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Values?: number[] }): IntArray {
        return new IntArray(values);
    }

    public static _FromServerJson(json: any): IntArray {
        return new IntArray({ Values: json.Values });
    }

    /**
     * Creates an instance of IntArray from another instance of IntArray.
     * @param other The IntArray you want to clone
     * @returns A cloned IntArray
     */
    public static FromOther(other: IntArray): IntArray {
        return IntArray._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return IntArray.FromOther(this);
    }

    static NAME_OF_CLASS = 'IntArray';
}
